import { 
  ORDER_STATUS, 
  PAYMENT_METHOD, 
  CUSTOMER_STATUS, 
  TRANSACTION_STATUS,
  PRODUCT_STATUS,
  COUNTRIES 
} from '@/utils/constants'
import { generateOrderId, generateCustomerId } from '@/utils/formatters'

// Mock Products Data
export const mockProducts = [
  {
    id: '1',
    name: 'Premium Cotton T-Shirt',
    description: 'High-quality cotton t-shirt with modern fit',
    price: 29.99,
    discount: 10,
    taxIncluded: true,
    stockQuantity: 150,
    status: PRODUCT_STATUS.ACTIVE,
    featured: true,
    categories: ['apparel', 'shirts'],
    tags: ['cotton', 'casual', 'basic'],
    colors: ['#000000', '#ffffff', '#3b82f6'],
    images: ['/api/placeholder/300/300'],
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-20T14:30:00Z',
  },
  {
    id: '2',
    name: 'Designer Jeans',
    description: 'Premium denim jeans with perfect fit',
    price: 89.99,
    discount: 15,
    taxIncluded: true,
    stockQuantity: 75,
    status: PRODUCT_STATUS.ACTIVE,
    featured: false,
    categories: ['apparel', 'pants'],
    tags: ['denim', 'casual', 'designer'],
    colors: ['#1e3a8a', '#374151', '#000000'],
    images: ['/api/placeholder/300/300'],
    createdAt: '2024-01-10T08:00:00Z',
    updatedAt: '2024-01-18T16:45:00Z',
  },
  {
    id: '3',
    name: 'Wireless Headphones',
    description: 'High-quality wireless headphones with noise cancellation',
    price: 199.99,
    discount: 0,
    taxIncluded: false,
    stockQuantity: 25,
    status: PRODUCT_STATUS.ACTIVE,
    featured: true,
    categories: ['electronics', 'audio'],
    tags: ['wireless', 'headphones', 'premium'],
    colors: ['#000000', '#ffffff'],
    images: ['/api/placeholder/300/300'],
    createdAt: '2024-01-12T12:00:00Z',
    updatedAt: '2024-01-22T09:15:00Z',
  },
]

// Mock Orders Data
export const mockOrders = [
  {
    id: generateOrderId(),
    orderNumber: 'ORD-001',
    customerId: 'CUST-001',
    customerName: 'John Doe',
    customerEmail: 'john@example.com',
    customerPhone: '+1-212-555-0101',
    items: [
      {
        productId: '1',
        productName: 'Premium Cotton T-Shirt',
        quantity: 2,
        price: 29.99,
        total: 59.98,
      },
    ],
    subtotal: 59.98,
    tax: 4.80,
    shipping: 5.00,
    total: 69.78,
    status: ORDER_STATUS.COMPLETED,
    paymentMethod: PAYMENT_METHOD.CREDIT_CARD,
    paymentStatus: 'paid',
    shippingAddress: {
      street: '123 Main St',
      city: 'New York',
      state: 'NY',
      zipCode: '10001',
      country: 'US',
    },
    createdAt: '2024-01-20T10:30:00Z',
    updatedAt: '2024-01-21T14:15:00Z',
    deliveredAt: '2024-01-23T16:00:00Z',
  },
  {
    id: generateOrderId(),
    orderNumber: 'ORD-002',
    customerId: 'CUST-002',
    customerName: 'Jane Smith',
    customerEmail: 'jane@example.com',
    customerPhone: '+1-310-555-0202',
    items: [
      {
        productId: '2',
        productName: 'Designer Jeans',
        quantity: 1,
        price: 89.99,
        total: 89.99,
      },
    ],
    subtotal: 89.99,
    tax: 7.20,
    shipping: 0.00,
    total: 97.19,
    status: ORDER_STATUS.PENDING,
    paymentMethod: PAYMENT_METHOD.PAYPAL,
    paymentStatus: 'pending',
    shippingAddress: {
      street: '456 Oak Ave',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90210',
      country: 'US',
    },
    createdAt: '2024-01-21T14:20:00Z',
    updatedAt: '2024-01-21T14:20:00Z',
  },
  {
    id: generateOrderId(),
    orderNumber: 'ORD-003',
    customerId: 'CUST-003',
    customerName: 'Bob Johnson',
    customerEmail: 'bob@example.com',
    customerPhone: '+1-312-555-0303',
    items: [
      {
        productId: '3',
        productName: 'Wireless Headphones',
        quantity: 1,
        price: 199.99,
        total: 199.99,
      },
    ],
    subtotal: 199.99,
    tax: 16.00,
    shipping: 0.00,
    total: 215.99,
    status: ORDER_STATUS.DELIVERED,
    paymentMethod: PAYMENT_METHOD.CREDIT_CARD,
    paymentStatus: 'paid',
    shippingAddress: {
      street: '789 Pine St',
      city: 'Chicago',
      state: 'IL',
      zipCode: '60601',
      country: 'US',
    },
    createdAt: '2024-01-18T09:15:00Z',
    updatedAt: '2024-01-22T11:30:00Z',
    deliveredAt: '2024-01-22T11:30:00Z',
  },
  // Additional dummy orders for export/testing
  {
    id: generateOrderId(),
    orderNumber: 'ORD-004',
    customerId: 'CUST-004',
    customerName: 'Sanjay Kumar',
    customerEmail: 'sanjay.kumar@example.com',
    customerPhone: '+91-98200-00001',
    items: [
      { productId: '1', productName: 'Premium Cotton T-Shirt', quantity: 1, price: 29.99, total: 29.99 },
      { productId: '2', productName: 'Designer Jeans', quantity: 1, price: 89.99, total: 89.99 },
    ],
    subtotal: 119.98,
    tax: 9.60,
    shipping: 5.00,
    total: 134.58,
    status: ORDER_STATUS.COMPLETED,
    paymentMethod: PAYMENT_METHOD.CREDIT_CARD,
    paymentStatus: 'paid',
    shippingAddress: { street: '12 MG Road', city: 'Mumbai', state: 'MH', zipCode: '400001', country: 'IN' },
    createdAt: '2025-11-28T08:30:00Z',
    updatedAt: '2025-11-28T09:00:00Z',
    deliveredAt: '2025-11-29T12:00:00Z',
  },
  {
    id: generateOrderId(),
    orderNumber: 'ORD-005',
    customerId: 'CUST-005',
    customerName: 'Priya Sharma',
    customerEmail: 'priya.sharma@example.com',
    customerPhone: '+91-98450-00002',
    items: [
      { productId: '3', productName: 'Wireless Headphones', quantity: 2, price: 199.99, total: 399.98 },
    ],
    subtotal: 399.98,
    tax: 32.00,
    shipping: 0.00,
    total: 431.98,
    status: ORDER_STATUS.PENDING,
    paymentMethod: PAYMENT_METHOD.PAYPAL,
    paymentStatus: 'pending',
    shippingAddress: { street: '200 Brigade Rd', city: 'Bengaluru', state: 'KA', zipCode: '560001', country: 'IN' },
    createdAt: '2025-11-25T11:15:00Z',
    updatedAt: '2025-11-25T11:15:00Z',
  },
  {
    id: generateOrderId(),
    orderNumber: 'ORD-006',
    customerId: 'CUST-006',
    customerName: 'Amit Verma',
    customerEmail: 'amit.verma@example.com',
    customerPhone: '+91-98330-00003',
    items: [
      { productId: '1', productName: 'Premium Cotton T-Shirt', quantity: 3, price: 29.99, total: 89.97 },
    ],
    subtotal: 89.97,
    tax: 7.20,
    shipping: 5.00,
    total: 102.17,
    status: ORDER_STATUS.DELIVERED,
    paymentMethod: PAYMENT_METHOD.BANK_TRANSFER,
    paymentStatus: 'paid',
    shippingAddress: { street: '10 Park St', city: 'Kolkata', state: 'WB', zipCode: '700016', country: 'IN' },
    createdAt: '2025-11-22T09:45:00Z',
    updatedAt: '2025-11-23T10:00:00Z',
    deliveredAt: '2025-11-24T16:30:00Z',
  },
  {
    id: generateOrderId(),
    orderNumber: 'ORD-007',
    customerId: 'CUST-007',
    customerName: 'Neha Patel',
    customerEmail: 'neha.patel@example.com',
    customerPhone: '+91-98760-00004',
    items: [
      { productId: '2', productName: 'Designer Jeans', quantity: 1, price: 89.99, total: 89.99 },
      { productId: '3', productName: 'Wireless Headphones', quantity: 1, price: 199.99, total: 199.99 },
    ],
    subtotal: 289.98,
    tax: 23.20,
    shipping: 10.00,
    total: 323.18,
    status: ORDER_STATUS.COMPLETED,
    paymentMethod: PAYMENT_METHOD.CREDIT_CARD,
    paymentStatus: 'paid',
    shippingAddress: { street: '5 MG Marg', city: 'Chennai', state: 'TN', zipCode: '600001', country: 'IN' },
    createdAt: '2025-11-20T14:10:00Z',
    updatedAt: '2025-11-20T15:00:00Z',
    deliveredAt: '2025-11-22T10:00:00Z',
  },
  {
    id: generateOrderId(),
    orderNumber: 'ORD-008',
    customerId: 'CUST-008',
    customerName: 'Rohit Singh',
    customerEmail: 'rohit.singh@example.com',
    customerPhone: '+91-98120-00005',
    items: [
      { productId: '1', productName: 'Premium Cotton T-Shirt', quantity: 4, price: 29.99, total: 119.96 },
    ],
    subtotal: 119.96,
    tax: 9.60,
    shipping: 5.00,
    total: 134.56,
    status: ORDER_STATUS.CANCELED,
    paymentMethod: PAYMENT_METHOD.CREDIT_CARD,
    paymentStatus: 'refunded',
    shippingAddress: { street: '77 Nehru St', city: 'Lucknow', state: 'UP', zipCode: '226001', country: 'IN' },
    createdAt: '2025-11-15T08:00:00Z',
    updatedAt: '2025-11-16T09:00:00Z',
  },
  {
    id: generateOrderId(),
    orderNumber: 'ORD-009',
    customerId: 'CUST-009',
    customerName: 'Kamala Rao',
    customerEmail: 'kamala.rao@example.com',
    customerPhone: '+91-88880-00006',
    items: [
      { productId: '3', productName: 'Wireless Headphones', quantity: 1, price: 199.99, total: 199.99 },
    ],
    subtotal: 199.99,
    tax: 16.00,
    shipping: 0.00,
    total: 215.99,
    status: ORDER_STATUS.DELIVERED,
    paymentMethod: PAYMENT_METHOD.PAYPAL,
    paymentStatus: 'paid',
    shippingAddress: { street: '88 MG Rd', city: 'Pune', state: 'MH', zipCode: '411001', country: 'IN' },
    createdAt: '2025-10-30T10:00:00Z',
    updatedAt: '2025-11-01T12:00:00Z',
    deliveredAt: '2025-11-03T16:00:00Z',
  },
  {
    id: generateOrderId(),
    orderNumber: 'ORD-010',
    customerId: 'CUST-010',
    customerName: 'Vikram Joshi',
    customerEmail: 'vikram.joshi@example.com',
    customerPhone: '+91-99550-00007',
    items: [
      { productId: '2', productName: 'Designer Jeans', quantity: 2, price: 89.99, total: 179.98 },
    ],
    subtotal: 179.98,
    tax: 14.40,
    shipping: 5.00,
    total: 199.38,
    status: ORDER_STATUS.PENDING,
    paymentMethod: PAYMENT_METHOD.CREDIT_CARD,
    paymentStatus: 'pending',
    shippingAddress: { street: '4 Church St', city: 'Jaipur', state: 'RJ', zipCode: '302001', country: 'IN' },
    createdAt: '2025-11-10T13:25:00Z',
    updatedAt: '2025-11-10T13:25:00Z',
  },
  {
    id: generateOrderId(),
    orderNumber: 'ORD-011',
    customerId: 'CUST-011',
    customerName: 'Leena Mehta',
    customerEmail: 'leena.mehta@example.com',
    customerPhone: '+91-97670-00008',
    items: [
      { productId: '1', productName: 'Premium Cotton T-Shirt', quantity: 1, price: 29.99, total: 29.99 },
      { productId: '3', productName: 'Wireless Headphones', quantity: 1, price: 199.99, total: 199.99 },
    ],
    subtotal: 229.98,
    tax: 18.40,
    shipping: 10.00,
    total: 258.38,
    status: ORDER_STATUS.COMPLETED,
    paymentMethod: PAYMENT_METHOD.BANK_TRANSFER,
    paymentStatus: 'paid',
    shippingAddress: { street: '21 Lake View', city: 'Hyderabad', state: 'TG', zipCode: '500001', country: 'IN' },
    createdAt: '2025-11-05T09:00:00Z',
    updatedAt: '2025-11-06T10:00:00Z',
    deliveredAt: '2025-11-08T14:00:00Z',
  },
  {
    id: generateOrderId(),
    orderNumber: 'ORD-012',
    customerId: 'CUST-012',
    customerName: 'Rina Desai',
    customerEmail: 'rina.desai@example.com',
    customerPhone: '+91-96660-00009',
    items: [
      { productId: '2', productName: 'Designer Jeans', quantity: 1, price: 89.99, total: 89.99 },
    ],
    subtotal: 89.99,
    tax: 7.20,
    shipping: 5.00,
    total: 102.19,
    status: ORDER_STATUS.COMPLETED,
    paymentMethod: PAYMENT_METHOD.CREDIT_CARD,
    paymentStatus: 'paid',
    shippingAddress: { street: '3 Main Bazar', city: 'Varanasi', state: 'UP', zipCode: '221001', country: 'IN' },
    createdAt: '2025-11-01T07:30:00Z',
    updatedAt: '2025-11-01T09:00:00Z',
    deliveredAt: '2025-11-03T12:00:00Z',
  },
]

// If more orders are needed for testing, generate them programmatically.
// This keeps the file manageable while providing many test records (ORD-013 -> ORD-112).
;(function generateBulkOrders() {
  const existingCount = mockOrders.length
  const targetEnd = 112 // create up to ORD-112 (ORD-013..ORD-112 => 100 additional)
  const statuses = [ORDER_STATUS.COMPLETED, ORDER_STATUS.PENDING, ORDER_STATUS.DELIVERED, ORDER_STATUS.CANCELED]
  const payments = [PAYMENT_METHOD.CREDIT_CARD, PAYMENT_METHOD.PAYPAL, PAYMENT_METHOD.BANK_TRANSFER]
  const productMap = {
    1: { id: '1', name: 'Premium Cotton T-Shirt', price: 29.99 },
    2: { id: '2', name: 'Designer Jeans', price: 89.99 },
    3: { id: '3', name: 'Wireless Headphones', price: 199.99 },
  }

  for (let n = existingCount + 1; n <= targetEnd; n++) {
    const idx = n // human-friendly index (starts after existing entries)
    const orderNum = idx // we want ORD-013.. etc; existing entries had custom numbers up to ORD-012
    if (orderNum <= 12) continue

    const orderNumber = `ORD-${String(orderNum).padStart(3, '0')}`
    const custId = `CUST-${String(orderNum).padStart(3, '0')}`
    const custName = `Test Customer ${orderNum}`
    const custEmail = `customer${orderNum}@example.com`
    const custPhone = `+91-98${String(10000 + orderNum).slice(1)}`

    // choose a product deterministically
    const prodKey = (orderNum % 3) + 1
    const prod = productMap[prodKey]
    const qty = (orderNum % 4) + 1
    const itemTotal = +(prod.price * qty).toFixed(2)
    const subtotal = itemTotal
    const tax = +((subtotal * 0.08)).toFixed(2)
    const shipping = (orderNum % 5 === 0) ? 0 : 5.00
    const total = +((subtotal + tax + shipping)).toFixed(2)

    const status = statuses[orderNum % statuses.length]
    const paymentMethod = payments[orderNum % payments.length]
    const paymentStatus = status === ORDER_STATUS.CANCELED ? 'refunded' : (status === ORDER_STATUS.PENDING ? 'pending' : 'paid')

    // create a deterministic createdAt across 2024-2025
    const month = (orderNum % 12) // 0..11
    const day = ((orderNum % 27) + 1)
    const year = 2024 + Math.floor(orderNum / 13) % 2 // toggles between 2024 and 2025 for variety
    const createdAt = new Date(Date.UTC(year, month, day, 9, 0, 0)).toISOString()
    const updatedAt = new Date(Date.parse(createdAt) + 1000 * 60 * 60 * 24).toISOString()
    const deliveredAt = (status === ORDER_STATUS.DELIVERED || status === ORDER_STATUS.COMPLETED)
      ? new Date(Date.parse(createdAt) + 1000 * 60 * 60 * 24 * 3).toISOString()
      : undefined

    const order = {
      id: generateOrderId(),
      orderNumber,
      customerId: custId,
      customerName: custName,
      customerEmail: custEmail,
      customerPhone: custPhone,
      items: [{ productId: prod.id, productName: prod.name, quantity: qty, price: prod.price, total: itemTotal }],
      subtotal,
      tax,
      shipping,
      total,
      status,
      paymentMethod,
      paymentStatus,
      shippingAddress: { street: `${orderNum} Test St`, city: 'Test City', state: 'TS', zipCode: '000000', country: 'IN' },
      createdAt,
      updatedAt,
    }

    if (deliveredAt) order.deliveredAt = deliveredAt

    mockOrders.push(order)
  }
})()

// API Functions
export async function getProducts(filters = {}) {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500))
  
  let filtered = [...mockProducts]
  
  // Apply filters
  if (filters.search) {
    const search = filters.search.toLowerCase()
    filtered = filtered.filter(product => 
      product.name.toLowerCase().includes(search) ||
      product.description.toLowerCase().includes(search)
    )
  }
  
  if (filters.status) {
    filtered = filtered.filter(product => product.status === filters.status)
  }
  
  if (filters.category) {
    filtered = filtered.filter(product => 
      product.categories.includes(filters.category)
    )
  }
  
  // Apply sorting
  if (filters.sort) {
    filtered.sort((a, b) => {
      const order = filters.order === 'desc' ? -1 : 1
      
      switch (filters.sort) {
        case 'name':
          return order * a.name.localeCompare(b.name)
        case 'price':
          return order * (a.price - b.price)
        case 'stock':
          return order * (a.stockQuantity - b.stockQuantity)
        case 'created':
          return order * (new Date(a.createdAt) - new Date(b.createdAt))
        default:
          return 0
      }
    })
  }
  
  // Apply pagination
  const page = filters.page || 1
  const size = filters.size || 10
  const start = (page - 1) * size
  const end = start + size
  
  return {
    data: filtered.slice(start, end),
    meta: {
      page,
      size,
      total: filtered.length,
      totalPages: Math.ceil(filtered.length / size),
    },
  }
}

export async function getProduct(id) {
  await new Promise(resolve => setTimeout(resolve, 300))
  
  const product = mockProducts.find(p => p.id === id)
  if (!product) {
    throw new Error('Product not found')
  }
  
  return product
}

export async function createProduct(productData) {
  await new Promise(resolve => setTimeout(resolve, 800))
  
  const newProduct = {
    id: (mockProducts.length + 1).toString(),
    ...productData,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  }
  
  mockProducts.push(newProduct)
  return newProduct
}

export async function updateProduct(id, productData) {
  await new Promise(resolve => setTimeout(resolve, 800))
  
  const index = mockProducts.findIndex(p => p.id === id)
  if (index === -1) {
    throw new Error('Product not found')
  }
  
  mockProducts[index] = {
    ...mockProducts[index],
    ...productData,
    updatedAt: new Date().toISOString(),
  }
  
  return mockProducts[index]
}

export async function deleteProduct(id) {
  await new Promise(resolve => setTimeout(resolve, 500))
  
  const index = mockProducts.findIndex(p => p.id === id)
  if (index === -1) {
    throw new Error('Product not found')
  }
  
  mockProducts.splice(index, 1)
  return { success: true }
}